const localeInitialState = {
    locale: null,
    country: null,
    regions:null,
    state: null,
    language: null,
    apiCountryData: null,
    markets: null,
    marketCurrency: { symbol: null, code: null },
    translations:null,
    langOptions:null,
    featureFlags:null,
    shippingMethods:null,
    filteredShippingMethods:[],
    preloaded : null
};
export default localeInitialState



// WEBPACK FOOTER //
// ./src/store/initialStates/localeInitialState.js